import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('issue_table_frozen_columns');
	},
};
